import {HttpBatchLink, HttpLink} from 'apollo-angular/http';
import {CommonModule} from '@angular/common';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {ErrorHandler, NgModule} from '@angular/core';
import {I18NextModule} from 'angular-i18next';
import {ErrorFabricService} from 'app/core/error-handler/error-fabric.service';
import {FreezingErrorsDetector} from 'app/core/error-handler/freezing-errors-detector';
import {HttpErrorInterceptor} from 'app/core/error-handler/http-error-interceptor';
import {DemoService} from 'app/core/services/demo.service';
import {DisableDemoService} from 'app/core/services/disable-demo.service';
import {LanguageSwitcherService} from 'app/core/services/language-switcher.service';
import {LocalStorageService} from 'app/core/services/local-storage.service';
import {PlaceholdersService} from 'app/core/services/placeholders.service';
import {ServerTimeService} from 'app/core/services/server-time.service';
import {SvgService} from 'app/core/services/svg.service';
import {UserpilotService} from 'app/core/services/userpilot.service';
import {MixpanelGuard} from 'app/guards/mixpanel.guard';
import {PermissionsGuard} from 'app/guards/permissions.guard';
import {UnsavedDataGuard} from 'app/guards/unsaved-data.guard';
import {CookieService} from 'ngx-cookie-service';
import {ApiModule} from 'src/app/shared/modules/api/api.module';
import {environment} from 'src/environments/environment';
import {DEFAULT_APOLLO_LINK, defaultApolloLinkFactory} from './apollo/apollo-client.provider';
import {APP_INITIALIZERS} from './app-initializers/app-initializers.providers';
import {AppErrorHandler} from './error-handler/app.error-handler';
import {ErrorNotifierService} from './error-handler/error-notifier.service';
import {DummySentry, Sentry, SentryConfig} from './error-handler/sentry.service';
import {LEGACY_REDIRECT_TO_LOGIN_PROVIDER, REDIRECT_PROVIDER, REDIRECT_TO_LEGACY_LOGIN} from './helpers/redirect';
import {I18N_PROVIDERS, I18NEXT_OPTIONS, i18nextOptions} from './i18next.provider';
import {AuthService, TokenRefresher} from './services/auth.service';
import {CountryService} from './services/country.service';
import {DomService} from './services/dom.service';
import {FormService} from './services/form.service';
import {MixpanelService} from './services/mixpanel.service';
import {OverlayService} from './services/overlay.service';
import {TooltipService} from './services/tooltip.service';
import {I18nextFormattersService} from 'app/core/services/i18next-formatters.service';
import {SessionStorageService} from 'app/core/services/session-storage.service';
import {HubspotService} from 'app/core/services/hubspot.service';
import {DefaultMainPageService} from 'app/core/services/default-main-page.service';
import {ThemeCustomizationService} from 'app/core/services/theme-customization.service';
import {AcceptTermsService} from 'app/core/services/accept-terms.service';
import {YandexMetricaService} from 'app/core/services/yandex-metrica.service';
import {PosthogService} from 'app/core/services/analytics/posthog.service';
import {ManageAppService} from 'app/features/apps/services/manage-app.service';

@NgModule({
    imports: [CommonModule, HttpClientModule, ApiModule, I18NextModule.forRoot()],
    providers: [
        SessionStorageService,
        LocalStorageService,
        LEGACY_REDIRECT_TO_LOGIN_PROVIDER,
        REDIRECT_PROVIDER,
        FormService,
        ...APP_INITIALIZERS,
        {provide: I18NEXT_OPTIONS, useValue: i18nextOptions},
        ...I18N_PROVIDERS,
        PosthogService,
        LanguageSwitcherService,
        {
            provide: DEFAULT_APOLLO_LINK,
            useFactory: defaultApolloLinkFactory,
            deps: [HttpLink, HttpBatchLink],
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpErrorInterceptor,
            multi: true,
            deps: [AuthService, ErrorNotifierService, ErrorFabricService, REDIRECT_TO_LEGACY_LOGIN],
        },
        PermissionsGuard,
        MixpanelGuard,
        FreezingErrorsDetector,
        ErrorNotifierService,
        CountryService,
        CookieService,
        {provide: SentryConfig, useValue: environment.sentry},
        {provide: Sentry, useClass: environment.sentry ? Sentry : DummySentry},
        {provide: ErrorHandler, useClass: AppErrorHandler},
        TokenRefresher,
        UserpilotService,
        HubspotService,
        MixpanelService,
        ManageAppService,
        AuthService,
        DemoService,
        DisableDemoService,
        DomService,
        DefaultMainPageService,
        TooltipService,
        OverlayService,
        SvgService,
        UnsavedDataGuard,
        ServerTimeService,
        PlaceholdersService,
        I18nextFormattersService,
        ThemeCustomizationService,
        AcceptTermsService,
        YandexMetricaService,
    ],
    exports: [],
})
export class CoreModule {}
